// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scriptTable .table:not(:last-child) {
  margin-bottom: 1.5rem;
}
.scriptTable .table {
  background-color: #fff;
  color: #363636;
  border-collapse: separate;
}
.scriptTable .table td,
.scriptTable .table th {
  max-width: 150px;
}
.scriptTable .table td:first-child,
.scriptTable .table th:first-child {
  padding-left: 25px;
}
.scriptTable .table th {
  color: #363636;
}
.scriptTable .table th:not([align]) {
  text-align: left;
}
.scriptTable .table thead {
  background-color: transparent;
}
.scriptTable .table thead td,
.scriptTable .table thead th {
  border-width: 0 0 2px;
  color: #363636;
}
.scriptTable .table tfoot {
  background-color: transparent;
}
.scriptTable .table tfoot td,
.scriptTable .table tfoot th {
  border-width: 2px 0 0;
  color: #363636;
}
.scriptTable .table tbody {
  background-color: transparent;
}
.scriptTable .table tbody tr {
  cursor: pointer;
}
.scriptTable .table tbody tr td,
.scriptTable .table tbody tr th {
  border-bottom: 1px solid var(--bs-border-color);
}
.scriptTable .table tbody tr:last-child td,
.scriptTable .table tbody tr:last-child th {
  border-bottom-width: 0;
}
.scriptTable .table tbody tr.isSelected.unFinished td,
.scriptTable .table tbody tr.isSelected td {
  background-color: #e8e8f0 !important;
}
.scriptTable .table tbody tr.unFinished td {
  background-color: #ffefeb !important;
}
.scriptTable .table.is-hoverable tbody tr:hover {
  background-color: #fafafa;
}
.scriptTable .table.is-hoverable.is-striped tbody tr:hover {
  background-color: #fafafa;
}
.scriptTable .table.is-hoverable.is-striped tbody tr:hover:nth-child(even) {
  background-color: #f5f5f5;
}
.scriptTable .table.is-striped tbody tr:nth-child(even) {
  background-color: #fafafa;
}
.scriptTable table.table thead th {
  min-width: 60px;
}
.scriptTable table.table td {
  color: #444;
}
.scriptTable table.table td .image {
  width: 1.5rem;
  height: 1.5rem;
}
@media screen and (min-width: 769px) {
  .scriptTable .b-table td,
  .scriptTable .b-table th {
    border: 1px solid #fafafa;
    border-width: 0 0 1px;
    padding: 0.5em 0.75em;
    vertical-align: top;
  }
  .scriptTable .b-table td:first-child, .scriptTable .b-table td:last-child,
  .scriptTable .b-table th:first-child,
  .scriptTable .b-table th:last-child {
    padding-left: 2em;
  }
}
@media screen and (max-width: 768px) {
  .scriptTable .b-table .table thead {
    display: none;
  }
  .scriptTable .b-table .table tfoot th {
    border: 0;
    display: inherit;
  }
  .scriptTable .b-table .table tr {
    -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
    max-width: 100%;
    position: relative;
    display: block;
    margin-bottom: 3px !important;
  }
  .scriptTable .b-table .table tr td {
    border: 0;
    display: inherit;
    padding: 0.1rem 1rem;
  }
  .scriptTable .b-table .table tr td:last-child {
    border-bottom: 0;
  }
  .scriptTable .b-table .table tr:not(:last-child) {
    margin-bottom: 1rem;
  }
  .scriptTable .b-table .table tr:not([class*=is-]) {
    background: inherit;
  }
  .scriptTable .b-table .table tr:not([class*=is-]):hover {
    background-color: inherit;
  }
  .scriptTable .b-table .table tr.detail {
    margin-top: -1rem;
  }
  .scriptTable .b-table .table tr:not(.detail) td {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: auto;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    text-align: right;
    border-bottom: 1px solid #f5f5f5;
  }
  .scriptTable .b-table .table tr:not(.detail) td:before {
    content: attr(data-label);
    font-weight: 600;
    padding-right: 0.5em;
    text-align: left;
  }
}
.scriptTable .table.is-hoverable.is-striped tbody tr:hover:nth-child(even) {
  background-color: #fafafa;
}
.scriptTable .b-table .table-main {
  overflow-x: scroll;
}
.scriptTable .b-table .table {
  border: 0;
  border-radius: 0;
}
.scriptTable .b-table .table-wrapper {
  margin-bottom: 0;
}
.scriptTable .b-table .table-wrapper + .level {
  padding: 1.125rem 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin: 0;
  border-top: rgba(24, 28, 33, 0.06);
  background: #f5f5f5;
}
@media screen and (max-width: 768px) {
  .scriptTable .b-table .table tr {
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1);
    margin-bottom: 3px !important;
  }
}
.scriptTable .page-item.active .page-link {
  z-index: 0 !important;
}`, "",{"version":3,"sources":["webpack://./packages/dre-magi-translate/frontend/src/pages/admin/project/segment/script/list/ScriptTable/ScriptTableMobile.scss"],"names":[],"mappings":"AACE;EACE,qBAAA;AAAJ;AAGE;EACE,sBAAA;EACA,cAAA;EACA,yBAAA;AADJ;AAGI;;EAEE,gBAAA;AADN;AAII;;EAEE,kBAAA;AAFN;AAKI;EACE,cAAA;AAHN;AAIM;EACE,gBAAA;AAFR;AAKI;EACE,6BAAA;AAHN;AAKM;;EAEE,qBAAA;EACA,cAAA;AAHR;AAOI;EACE,6BAAA;AALN;AAOM;;EAEE,qBAAA;EACA,cAAA;AALR;AASI;EACE,6BAAA;AAPN;AASM;EACE,eAAA;AAPR;AAQQ;;EAEE,+CAAA;AANV;AAWQ;;EAEE,sBAAA;AATV;AAcQ;;EACE,oCAAA;AAXV;AAeQ;EACE,oCAAA;AAbV;AAmBM;EACE,yBAAA;AAjBR;AAoBM;EACE,yBAAA;AAlBR;AAoBQ;EACE,yBAAA;AAlBV;AAuBI;EACE,yBAAA;AArBN;AA0BI;EAEE,eAAA;AAzBN;AA4BI;EACE,WAAA;AA1BN;AA2BM;EACE,aAAA;EACA,cAAA;AAzBR;AA+BI;EACE;;IAME,yBAAA;IACA,qBAAA;IACA,qBAAA;IACA,mBAAA;EAjCN;EA0BM;;;IAEE,iBAAA;EAvBR;AACF;AA8BI;EAEI;IACE,aAAA;EA7BR;EA+BM;IACE,SAAA;IACA,gBAAA;EA7BR;EA+BM;IACE,oFACE;IAEF,2CAAA;IACA,eAAA;IACA,kBAAA;IACA,cAAA;IACA,6BAAA;EA/BR;EAkCM;IACE,SAAA;IACA,gBAAA;IACA,oBAAA;EAhCR;EAmCM;IACE,gBAAA;EAjCR;EAoCM;IACE,mBAAA;EAlCR;EAqCM;IACE,mBAAA;EAnCR;EAsCM;IACE,yBAAA;EApCR;EAuCM;IACE,iBAAA;EArCR;EAwCM;IACE,oBAAA;IACA,oBAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;IACA,sBAAA;IACA,8BAAA;IACA,iBAAA;IACA,gCAAA;EAtCR;EAyCM;IACE,yBAAA;IACA,gBAAA;IACA,oBAAA;IACA,gBAAA;EAvCR;AACF;AA4CE;EACE,yBAAA;AA1CJ;AA8CI;EACE,kBAAA;AA5CN;AA8CI;EACE,SAAA;EACA,gBAAA;AA5CN;AA+CI;EACE,gBAAA;AA7CN;AA+CM;EACE,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,SAAA;EACA,kCAAA;EACA,mBAAA;AA7CR;AAkDE;EAGM;IACE,2CAAA;IACA,6BAAA;EAlDR;AACF;AAuDE;EACE,qBAAA;AArDJ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
